import React from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { wire } from "react-hot-wire";

import { SiteService } from "services/site/Site.service";

import { Application } from "models/application/Application";

import Drawer from "components/common/drawer/Drawer";

import AddSubscription from "./AddSubscription.template";

export type AddApplicationSubscriptionFormValues = {
  startDate: Date;
  endDate: Date;
  product: "onboarding" | "development" | "exit";
  credits: number;
  creditPrice: number;
};

const AddUserSchema = Yup.object().shape({
  startDate: Yup.date().required(),
  endDate: Yup.date()
    .when(
      "startDate",
      (startDate, schema) => startDate && schema.min(startDate)
    )
    .required(),
  product: Yup.string()
    .oneOf(["onboarding", "development", "exit"])
    .required(),
  credits: Yup.number().required(),
  creditPrice: Yup.number().required()
});

function AddSubscriptionComponent({
  application,
  siteService,
  drawerProps,
  action
}: {
  application: Application;
  siteService: SiteService;
  drawerProps?: any;
  action?: () => void;
}) {
  const currentDate = new Date();

  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) => (
        <Formik
          initialValues={{
            startDate: currentDate,
            endDate: new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              currentDate.getDate() + 1
            ),
            product: "onboarding",
            credits: 1,
            creditPrice: 1
          }}
          validationSchema={AddUserSchema}
          isInitialValid
          onSubmit={(values: AddApplicationSubscriptionFormValues) =>
            siteService
              .addApplicationSubscription({
                values,
                application
              })
              .then(close)
              .then(action)
          }
          render={(
            props: FormikProps<AddApplicationSubscriptionFormValues>
          ) => <AddSubscription formikProps={props} close={close} />}
        />
      )}
    />
  );
}

export default wire(["siteService"], AddSubscriptionComponent);
